/// <reference path="../_references.js" />

// 1. need to trap ALL user navigation events and on the events we need to refresh the token
// 2. when the user is inactive for 5 minutes we need to pop up a warning dialog
// 3. when the user doesn't click the session timeout warning we need to redirect to login.html

if (isNullOrUndefined(veritracks.security)) {
    veritracks.security = {};
}

veritracks.security.AuthenticationController = function () {
    "use strict";
    var self = this,

        mCookie = '',
        mSessionWarningTimerId = -1,
        mSessionIntervalInMinutes = 50,// Initial Interval... set Cookie
        mSessionTimerInterval = (48 * 1000 * 60),// Timer till show Warning 
        mSessionTimeoutWaitInterval = (2 * 1000 * 60),// Time to handle warning before logout automatically 
            
        mServerSessionInterval = (5 * 1000 * 60), // Every 5 minutes calls POST /ExtendSession (v11 service)  extending session.
        mServerSessionTimerId = -1,
        mTimerEnabled = true,
        mJWT ='';

    this.EnableTimer = function (aEnabled) {
        mTimerEnabled = aEnabled;
        if (!aEnabled) {
            window.setInterval(ExtendServerSession, 10 * 1000 * 60);
        }
    }

    this.SetTimer = function (aTimer) {
        mServerSessionInterval = (aTimer * 1000 * 60);
    }
    this.getJWT = function (cb){
        function aOnSuccess (aParams, uToken){
            mJWT = uToken;    
            cb(mJWT);
        }
        function onFailure(err){
            console.log(err);
        }
        if(mJWT ===''){
            var lToken = self.getCookie('VeritracksAuthenticationToken');
            if(lToken){
                return callAjax('VeritracksAuthWithJWT', {
                    "aSecurityToken":lToken
                },aOnSuccess,onFailure,{},false);
                console.log('yes');
            }
        }
        cb(mJWT);
    };
    this.clearJWT = function(){
        mJWT ='';
    }
    this.setCookie = function (aPropertyName, aValue, aExtensionInMinutes) {
        var lExpirationDate = new Date(),
            lExtensionInMinutes = mSessionIntervalInMinutes,
            lValue;

        if (!isNullOrUndefined(aExtensionInMinutes)) {
            lExtensionInMinutes = aExtensionInMinutes;
        }

        lExpirationDate.setMinutes(lExpirationDate.getMinutes() + lExtensionInMinutes);
        lValue = escape(aValue) + "; expires=" + lExpirationDate.toUTCString();
        mCookie = aPropertyName + "=" + lValue + ";path=/";
        top.name = mCookie;
        
        $('#uSecurityToken').val(escape(aValue));
    };

    this.SetCustomCookie = function (aPropertyName, aValue) {
        $('#' + aPropertyName).val(aValue);
    }

    this.getCookie = function (aPropertyName) {
        var i, x, y, lCookieArray = mCookie.split(";");
        for (i = 0; i < lCookieArray.length; i++) {
            x = lCookieArray[i].substr(0, lCookieArray[i].indexOf("="));
            y = lCookieArray[i].substr(lCookieArray[i].indexOf("=") + 1);
            x = x.replace(/^\s+|\s+$/g, "");
            if (x == aPropertyName) {
                return unescape(y);
            }
        }
    };

    this.clearCookie = function (aPropertyName) {
        self.setCookie(aPropertyName, "", -1);
    };

    this.extendCookie = function (aPropertyName) {
        var lResult = false,
            lCookieValue = self.getCookie(aPropertyName);
        if (!isNullOrUndefined(lCookieValue) && lCookieValue !== '') {
            self.setCookie(aPropertyName, lCookieValue);
            lResult = true;
        }
        return lResult;
    };
    this.tryGetSecurityJWT = function (aOnSuccess,onFailure){
        return mJWT;
    }
    this.tryGetSecurityToken = function () {
        var lResult = self.getCookie('VeritracksAuthenticationToken');
        if (isNullOrUndefined(lResult)) {
            window.clearTimeout(mSessionWarningTimerId);
            lResult = '';
            if (gSystemSettings.IsDebug) {
                veritracks.system.raiseFailure('tryGetSecurityToken: security token lost');
            } else {
                veritracks.system.redirectToLogin();
            }
        } else if (typeof lResult !== 'string') {
            veritracks.system.raiseFailure('Cookie is not a string. ' + lResult.toString());
        }
        return lResult;
    };

    this.extendSession = function () {
        window.clearTimeout(mSessionWarningTimerId);
        if (veritracks.security.controller.extendCookie('VeritracksAuthenticationToken')) {
            self.startTimer();
        } else {
            if (gSystemSettings.IsDebug) {
                veritracks.system.raiseFailure('extendSession: security token lost');
            } else {
                veritracks.system.redirectToLogin();
            }
        }
    };

    this.startTimer = function () {
        if (mTimerEnabled) {
            mSessionWarningTimerId = window.setTimeout(displaySessionTimeoutWarning, mSessionTimerInterval);//48 minutes + 2 minutes after warning  
            if (mServerSessionTimerId < 0) {
                startServerTimer();
            }
        }
    };

    this.systemTimeout = function () {
        window.location.href = window.location.origin +"/Account/Timeout.html";
    };

    this.expireSession = function (aCallback) {
        var success = function(){};

        if (!isNullOrUndefined(aCallback)){
            success = aCallback;
        }

        function failure(a, b, c, d) { }

        ExpireServerSession(success, failure, null);
    };

    function displaySessionTimeoutWarning() {
        var lButtonCommandBar = GenerateButtonCommandBar(),
            lTimerId = window.setTimeout(self.systemTimeout, mSessionTimeoutWaitInterval);

        stopServerTimer();
        window.clearTimeout(mSessionWarningTimerId);
        GenerateButton(localizeWrapper('cEnrolleeContinue'), 'Continue', 'veritracks.security.onExtendClick(' + lTimerId + ')').appendTo(lButtonCommandBar);

        DisplayPopup(localizeWrapper('cDefaultExtendSession'), localizeText('cDefaultExtendSessionExpire'), lButtonCommandBar, true);
    }

    function stopServerTimer() {
        if (mServerSessionTimerId > 0) {
            window.clearTimeout(mServerSessionTimerId);
            mServerSessionTimerId = -1;
        }
    }

    function onServerTick () {
        stopServerTimer();
        ExtendServerSession(null);
        startServerTimer();
    }

    function startServerTimer () {
        stopServerTimer();
        mServerSessionTimerId = window.setTimeout(onServerTick, mServerSessionInterval);
    };

    if (!isNullOrUndefined(top.name) && top.name !== '') {
        mCookie = top.name;
    }

};

veritracks.security.onExtendClick = function (aTimerId) {
    "use strict";
    window.clearTimeout(aTimerId);
    veritracks.security.controller.extendSession();
    ClosePopup();
    if (!isNullOrUndefined(veritracks.system) && !isNullOrUndefined(veritracks.system.reshowCdcrLoginAcknowledgmentIfActive)) {
        veritracks.system.reshowCdcrLoginAcknowledgmentIfActive();
    }
}

veritracks.security.controller = new veritracks.security.AuthenticationController();

function clearAllCdcrLoginAcknowledgmentSessions() {
    "use strict";
    var lPrefix = 'cdcrLoginAckAccepted:',
        lSessionStorage,
        lKeysToRemove = [],
        lIndex,
        lKey;

    try {
        lSessionStorage = window.sessionStorage;
        if (isNullOrUndefined(lSessionStorage)) {
            return;
        }

        if (typeof lSessionStorage.key === 'function' && typeof lSessionStorage.length === 'number') {
            for (lIndex = 0; lIndex < lSessionStorage.length; lIndex++) {
                lKey = lSessionStorage.key(lIndex);
                if (typeof lKey === 'string' && lKey.indexOf(lPrefix) === 0) {
                    lKeysToRemove.push(lKey);
                }
            }
        } else {
            for (lKey in lSessionStorage) {
                if (Object.prototype.hasOwnProperty.call(lSessionStorage, lKey) && lKey.indexOf(lPrefix) === 0) {
                    lKeysToRemove.push(lKey);
                }
            }
        }

        for (lIndex = 0; lIndex < lKeysToRemove.length; lIndex++) {
            lSessionStorage.removeItem(lKeysToRemove[lIndex]);
        }
    } catch (aError) {
        // Session storage can be blocked; fail soft to avoid blocking login flow.
    }
}


veritracks.security.sso =  function clientKeyAuthentication() {
        "use strict";
        var lKey = gup('authenticationKey', window.location.search);
        var lClient = gup('client', window.location.search);
        if(lKey && lClient){
            window.callAjax('GetSSOService', { 'aKeyCredentials': { 'Key': lKey, 'Client': lClient } },function(aParams,lServiceUrl){
                gServiceUrlList = lServiceUrl + VERITRACKS_SERVICE_ENDPOINT;
                sessionStorage.veritracksservice = gServiceUrlList;
                beginClientKeyAuthentication(lKey, lClient);
            },function(a,b,c,aParams){
                //Error
                window.DisplayPopup('LOGIN ERROR', '<div> Incorrect Key used.... Closing Session</div>', null, false);
                window.setTimeout(function () {
                    window.close(); //close window.
                }, 3000);
            }).fail(function(jqXHR, textStatus){
                window.DisplayPopup('LOGIN '+textStatus.toUpperCase(), '<div> Incorrect Key or Client used.... Closing Session </div>', null, false);
            });
        }else {
            var txt =[];
            if(isNullOrUndefined(lClient)){
                txt.push('<b>Client</b>');
            }
            window.DisplayPopup('LOGIN ERROR', '<div> Parameter Missing or Invalid: '+txt.join(' ')+' </div>', null, false);
        }

        function beginClientKeyAuthentication(aKey, aClient) {
            "use strict";
            window.veritracks.security.controller.setCookie('VeritracksAuthenticationToken', 'invalidtoken');
            window.callAjax('AuthenticateClient',
                    { 'aKeyCredentials': { 'Key': aKey, 'Client': aClient } },
                    function (aOutParams, aToken) {
                        window.veritracks.security.controller.setCookie('VeritracksAuthenticationToken', aToken);
                        var queryString = window.location.search;   
                        var urlParams = new URLSearchParams(queryString);
                        var returnUrl = urlParams.get('SSOPath');    
                        window.veritracks.security.controller.SetCustomCookie("uReturnPath", returnUrl);    
                        clearAllCdcrLoginAcknowledgmentSessions();
                        window.location.href = '../?uReturnPath=' + returnUrl;
                    },
                    function () {
                        window.DisplayPopup('LOGIN ERROR', '<div> Incorrect Key used.... Closing Session</div>', null, false);
                        window.setTimeout(function () {
                           window.close(); //close window.
                        }, 3000);
                    },
                    null).fail(function(jqXHR, textStatus){
                        window.DisplayPopup('LOGIN '+textStatus.toUpperCase(), '<div> Incorrect Key or Client used.... Closing Session </div>', null, false);
                    });
        }
        /**
         * @deprecated 4.9.3
         * @param  {} aOutParams
         * @param  {} aToken
         */
        function clientKeyAuthenticationSuccess(aOutParams, aToken){
            "use strict";
            veritracks.security.controller.setCookie('VeritracksAuthenticationToken', aToken);
            clearAllCdcrLoginAcknowledgmentSessions();
            $('form:first').submit();
        }
           
}